import { Button, Stack } from 'core/common/ui/ui-kit';
import { ThemeDirection, ThemeMode, useThemeContext } from 'core/theme/contexts';

// TODO:: will be removed for production
export const DevThemeControls = () => {
  const { themeMode, changeTheme, direction, changeDirection } = useThemeContext();

  const handleThemeToggle = () =>
    changeTheme(themeMode === ThemeMode.LIGHT ? ThemeMode.DARK : ThemeMode.LIGHT);

  const handleDirectionToggle = () =>
    changeDirection(direction === ThemeDirection.LTR ? ThemeDirection.RTL : ThemeDirection.LTR);

  return (
    <Stack direction="row" spacing={2} sx={{ zIndex: 10000 }}>
      <Button size="small" variant="contained" onClick={handleThemeToggle}>
        {themeMode}
      </Button>
      <Button size="small" variant="contained" onClick={handleDirectionToggle}>
        {direction.toUpperCase()}
      </Button>
    </Stack>
  );
};
